module.exports = __webpack_public_path__ + "static/media/emprunteur.da94f491.png";